import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'browse',
		path: ['/browse', '/browse/:type'],
		component: loadable(async () => import(/* webpackChunkName: "pages/browse" */ './index'), {
			exportName: 'Browse',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			enabled: true,
			seo: true,
		},
	},
];
